import { GATEWAY_BASE_URL } from "../../../../constants";
import request from "../../../../util/APIUtils";

export const getCertificates = async (userId) => {
  if (!userId) {
    throw new Error('User ID is required');
  }
  
  return request({
    url: `${GATEWAY_BASE_URL}/programs/person/${userId}/certificates`,
    method: 'GET',
  });
};
